import endpoint from "../../config/endpoints";

export const holidayStructureAssignationJson = {
    showSaveNextBtn: true,
    formPath: "/holiday-structure-assignation-form",
    apiBaseURL: endpoint.holidayStructureAssignation,
    changeExcel: endpoint.exportData,
    screenTitle: "Holiday Structure Assignation",
    showAddButton: true,
    showPdfDownload: true,
    pdfFileName: "Holiday Structure Assignation",
    showExcelDownload: true,
    excelFileName: "Holiday Structure Assignation",
    formPathView: "/holiday-structure-view",
    isActiveURL: endpoint.holidayStructureAssignation + "/update-is-active",
    tableColumnsToFilter: [
        {
            columnDisplayName: "Sales Team Name",
            columnKeyName: "salesTeamName",
            isChecked: true,
        },
        {
            columnDisplayName: "Sales Team Type",
            columnKeyName: "salesTeamStockHolderTypName",
            isChecked: true,
        },
        {
            columnDisplayName: "Structure Name",
            columnKeyName: "structureName",
            isChecked: true,
        },
        {
            columnDisplayName: "From Date",
            columnKeyName: "fromDate",
            isChecked: true,
        },
        {
            columnDisplayName: "To Date",
            columnKeyName: "toDate",
            isChecked: true,
        }
    ],
    fieldMeta: [
        {
            label: "Holiday Structure",
            controlType: "autocomplete",
            placeHolder: "Select Holiday Structure",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "holidayStructureDetail",
            dataKey: "holidayStructureHeader",
            getListId: "holidayStructureHeader",
            isRootLevelKey: true,
            isMandatory: true,
        },
    ],
};
